import initialState from '../data/initialState';

export function servicesReducer(state=initialState.services,actions){
   return state;
}



// WEBPACK FOOTER //
// ./src/reducers/servicesReducer.js